import { useEffect, useState } from 'react'
import { api } from '../lib/api'

export default function WorkoutsPage() {
  const [programs, setPrograms] = useState<any[]>([])
  const [showLog, setShowLog] = useState(false)
  const [logForm, setLogForm] = useState({ durationMin: 30, notes: '' })
  const [logResult, setLogResult] = useState<any>(null)

  useEffect(() => {
    api.getPrograms().then(({ programs }) => setPrograms(programs)).catch(() => {})
  }, [])

  async function handleLogWorkout(e: React.FormEvent) {
    e.preventDefault()
    try {
      const result = await api.logWorkout({ durationMin: logForm.durationMin, notes: logForm.notes })
      setLogResult(result.xp)
      setLogForm({ durationMin: 30, notes: '' })
    } catch (err: any) {
      alert(err.message)
    }
  }

  return (
    <div>
      <div className="page-header">
        <h2>Workouts</h2>
        <p>Train hard. Level up. Repeat.</p>
      </div>

      {/* Quick Log */}
      <div className="card">
        <div className="card-header">
          <span className="card-title">Quick Log Workout</span>
          <button className="btn btn-secondary" onClick={() => setShowLog(!showLog)} style={{ padding: '0.4rem 0.8rem', fontSize: '0.8rem' }}>
            {showLog ? 'Close' : '+ Log Workout'}
          </button>
        </div>

        {logResult && (
          <div style={{ background: 'rgba(34, 204, 68, 0.1)', border: '1px solid rgba(34, 204, 68, 0.3)', padding: '1rem', marginBottom: '1rem', borderRadius: '2px', textAlign: 'center' }}>
            <span className="font-pixel" style={{ color: 'var(--gold)', fontSize: '0.7rem' }}>
              +{logResult.xpAwarded} XP{logResult.streakBonus > 0 ? ` (+${logResult.streakBonus} streak bonus!)` : ''}
            </span>
            {logResult.leveledUp && (
              <div style={{ marginTop: '0.5rem', fontSize: '1rem' }}>
                🎉 LEVEL UP! You are now Level {logResult.level} — {logResult.stage}
              </div>
            )}
            <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '0.25rem' }}>
              🔥 {logResult.streak} day streak
            </div>
          </div>
        )}

        {showLog && (
          <form onSubmit={handleLogWorkout}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '1rem' }}>
              <div className="form-group">
                <label className="form-label">Duration (min)</label>
                <input type="number" className="form-input" min={1} max={300} value={logForm.durationMin} onChange={e => setLogForm(prev => ({ ...prev, durationMin: parseInt(e.target.value) || 0 }))} />
              </div>
              <div className="form-group">
                <label className="form-label">Notes</label>
                <input type="text" className="form-input" placeholder="What did you crush today?" value={logForm.notes} onChange={e => setLogForm(prev => ({ ...prev, notes: e.target.value }))} />
              </div>
            </div>
            <button type="submit" className="btn btn-primary">Log & Earn XP</button>
          </form>
        )}
      </div>

      {/* Programs */}
      <div style={{ marginTop: '1.5rem' }}>
        <h3 className="font-pixel" style={{ fontSize: '0.7rem', color: 'var(--gold)', marginBottom: '1rem' }}>Programs</h3>
        {programs.length === 0 ? (
          <div className="card" style={{ textAlign: 'center', padding: '3rem' }}>
            <p style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🎮</p>
            <p style={{ color: 'var(--text-secondary)' }}>Programs coming soon! For now, log your workouts manually above.</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
            {programs.map(p => (
              <div key={p.id} className="card">
                <div className="card-title">{p.name}</div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', margin: '0.5rem 0' }}>{p.description}</p>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <span className={`badge badge-${p.difficulty?.toLowerCase() || 'common'}`}>{p.difficulty}</span>
                  <span className="badge badge-common">{p.category}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
